<template>
    <div :class="{'morelist': true, 'none': isjh}">
        <i class="icon i_list"></i><em>点我阅读</em>更多劲爆内容
        <span class="icon i_goto"></span>
    </div>
</template>

<script>
import { isBaiduBox } from "../../utils/base"
export default {
    name: "morelist",
    data () {
        return {
            isjh: false
        }
    },
    mounted () {
        if (isBaiduBox()) {
            this.isjh = true
        }
    }
}
</script>
